import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { Lesson } from '@/shared/types/lesson';

interface LessonsState {
  selectedLesson: Lesson | null;
  createDialogOpen: boolean;
  editDialogOpen: boolean;
  editingLesson: Lesson | null;
}

const initialState: LessonsState = {
  selectedLesson: null,
  createDialogOpen: false,
  editDialogOpen: false,
  editingLesson: null,
};

const lessonsSlice = createSlice({
  name: 'lessons',
  initialState,
  reducers: {
    setSelectedLesson: (state, action: PayloadAction<Lesson | null>) => {
      state.selectedLesson = action.payload;
    },
    openCreateDialog: (state) => {
      state.createDialogOpen = true;
      state.editingLesson = null;
    },
    closeCreateDialog: (state) => {
      state.createDialogOpen = false;
    },
    openEditDialog: (state, action: PayloadAction<Lesson>) => {
      state.editDialogOpen = true;
      state.editingLesson = action.payload;
    },
    closeEditDialog: (state) => {
      state.editDialogOpen = false;
      state.editingLesson = null;
    },
  },
});

export const {
  setSelectedLesson,
  openCreateDialog,
  closeCreateDialog,
  openEditDialog,
  closeEditDialog,
} = lessonsSlice.actions;

export default lessonsSlice.reducer;
